import * as React from 'react';
import {IconCircle} from '@tabler/icons';
import './loading.css';

export const IconLoading: React.FC = () => {
	return (
		<span className="icon-loading">
			<IconCircle />
		</span>
	);
};
